import { definirAppDeclaree } from '@taki/app-runtime';
import appInfo from './taki.app.json';
import champs from './taki.fields.json';
import ecrans from './taki.screens.json';
import { DossierDeLAnimal } from './canvas/DossierDeLAnimal.js';
import { FenetreConsulterMaintenant } from './canvas/FenetreConsulterMaintenant.js';
import { importDemoDataset } from './demo-dataset.js';

/**
 * LA VUE DE FICHE « Dossier de l'animal » (`vue:patients.dossier`) : sa carte
 * dans `vuesCustom` de `taki.screens.json` (niveau fiche, jeu des animaux), son
 * accord dans `canvas.views` de `taki.app.json` (regle G23), son rendu dans
 * `canvas/DossierDeLAnimal.tsx`. La Fiche native reste la, dans le selecteur.
 *
 * LE GESTE « Consulter maintenant » est declare sur la porte `animaux`
 * (`niveau: "fiche"`, fenetre `consulterMaintenant`) : le socle le rend sur
 * toutes les vues de la fiche, Fiche standard et Dossier de l'animal.
 */
export const patientsApp = definirAppDeclaree({
  fiche: appInfo,
  champs,
  ecrans,
  canvas: { 'vue:patients.dossier': DossierDeLAnimal },
  fenetres: { consulterMaintenant: FenetreConsulterMaintenant },
  demo: {
    ecrit: [{ family: 'contacts', type: 'person' }, { family: 'assets', type: 'animal' }],
    importer: ({ sdk, orgId }) => importDemoDataset(sdk, orgId),
  },
});
export default patientsApp;
